import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Homepage from "./pages/home/Homepage";
import Register from "./pages/register/Register";
import ForgetPassword from "./pages/forgetPassword/ForgetPassword";
import LinkExpired from "./pages/linkExpired/LinkExpired";
import ChangePassword from "./pages/changePassword/ChangePassword";
import Team from "./pages/team/Team";
import Login from "./pages/login/Login";
import CasesSharesOfInheritance from "./pages/cases/sharesOfInheritance";
import CasesTotalAssetsValue from "./pages/cases/totalAssets/TotalAssets";
import CasesPage from "./pages/cases";
import AppointmentList from "./pages/cases/appointment";
import PortfolioPage from "./pages/portfolio";
import NotAllowed from "./pages/notAllowed";
import Faq from "./pages/faq";

import { getUser } from "./services/profile";
import { useDispatch } from "react-redux";
import About from "./pages/about/About";
import { PermissionsProvider } from "../src/hooks/permission/usePermission";
import VerifyOptPage from "./pages/verifyOtp/VerifyOptPage";
import Imprint from "./pages/imprint/imprint";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy";
import GetStartedPage from "./pages/getStarted/GetStartedPage";
import ProfileManagerPage from "./pages/profileManager";
import { fetchTranslationsList } from "./redux/slices/TranslationSlice";
import ProfileSetting from "./pages/ProfileSettings";
import { AppMessage } from "./components/AppMessage";
import TermOfUse from "./pages/termOfUse/termOfUse";
import Donations from './pages/cases/donations/index';
export const routesMaping = (arr) => {
  return arr.map((item, index) => {
    let Component = require("." + item?.componentPath)?.default;
    if (item.hasOwnProperty("children")) {
      return (
        <Route key={item.route} path={item.route} element={<Component />}>
          {routesMaping(item.children)}
        </Route>
      );
    } else {
      return (
        <Route key={item.route} path={item.route} element={<Component />} />
      );
    }
  });
};

const App = () => {
  const [reloaded, setReloaded] = useState(false);
  const [appMessage, setAppMessage] = useState("");
  const [isAppMessageOpen, setIsAppMessageOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.addEventListener("localdatachanged", () => {
      if (!reloaded) setReloaded(true);
    });
  }, []);
  const fetchProfile = async () => {
    const { route, state, consultantEnabled, role } = await getUser(dispatch);
    if (!consultantEnabled && role == "#EU") {
      setAppMessage("consultant-not-assigned-message");
      setIsAppMessageOpen(true);
    }
    if (route !== null) navigate(route, { state: { ...state } });
  };
  useEffect(() => {
    if (
      location?.pathname !== "/faq" &&
      location?.pathname !== "/about" &&
      location?.pathname !== "/imprint" &&
      location?.pathname !== "/privacy-policy" &&
      location?.pathname !== "/login" &&
      location?.pathname !== "/admin/login" &&
      location?.pathname !== "/admin"
    ) {
      fetchProfile();
    }
    dispatch(fetchTranslationsList("All"));
  }, []);

  return (
    <>
      <PermissionsProvider>
        <Navbar />

        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/team" element={<Team />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/redirect" element={<ChangePassword />} />
          <Route path="/link-expired" element={<LinkExpired />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/not-allowed" element={<NotAllowed />} />
          <Route path="/verify-otp" element={<VerifyOptPage />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/term-of-use" element={<TermOfUse />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/profile" element={<ProfileManagerPage />} />
          <Route path="/setting" element={<ProfileSetting />} />
          <Route
            path="/admin"
            element={<Navigate replace to="/admin/login" />}
          />

          {/* navigation of parent routes */}
          <Route
            path="/your-assets"
            element={<Navigate replace to="/your-assets/family-tree" />}
          />
          <Route
            path="/your-wishes"
            element={<Navigate replace to="/your-wishes/status-quo" />}
          />
          <Route
            path="/documents"
            element={<Navigate replace to="/documents/healthcare-proxy" />}
          />
          <Route
            path="/cases"
            element={<Navigate replace to="/cases/cases-list" />}
          />
          <Route
            path="/appointments"
            element={<Navigate replace to="/appointments/appointments-list" />}
          />
          {/* all routes */}
          {localStorage.getItem("menuStructure") &&
            routesMaping(JSON.parse(localStorage.getItem("menuStructure")))}
          <Route path="/cases" element={<CasesPage />}>
            <Route
              path=":id/shares-of-inheritance"
              element={<CasesSharesOfInheritance />}
            ></Route>
            <Route
              path=":id/total-assets-value"
              element={<CasesTotalAssetsValue />}
            ></Route>
          </Route>
          <Route path="/appointments" element={<CasesPage />}>
            <Route
              path=":id/shares-of-inheritance"
              element={<CasesSharesOfInheritance />}
            ></Route>
            <Route
              path=":id/total-assets-value"
              element={<CasesTotalAssetsValue />}
            ></Route>
            <Route
              path=":id/donations"
              element={<Donations />}
            ></Route>
          </Route>

          <Route path="/appointment-list" element={<AppointmentList />} />
        </Routes>
      </PermissionsProvider>
      <AppMessage
        isOpen={isAppMessageOpen}
        message={appMessage}
        handleClose={() => {
          setIsAppMessageOpen(!isAppMessageOpen);
        }}
      />
    </>
  );
};

export default App;
